import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleAccessGuard } from './core/auth/role-access.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES
          )
      },
      {
        path: 'users',
        canActivate: [roleAccessGuard],
        data: { denyRoles: ['MEMBER', 'SECRETARY', 'COM_COMPTE', 'TREASURER'] },
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.USERS_ROUTES)
      },
      {
        path: 'roles',
        canActivate: [roleAccessGuard],
        data: { denyRoles: ['MEMBER', 'SECRETARY', 'COM_COMPTE', 'TREASURER'] },
        loadChildren: () =>
          import('./features/roles/roles.routes').then((m) => m.ROLES_ROUTES)
      },
      {
        path: 'tontines',
        loadChildren: () =>
          import('./features/tontines/tontines.routes').then(
            (m) => m.TONTINES_ROUTES
          )
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./features/invoices/invoices.routes').then(
            (m) => m.INVOICES_ROUTES
          )
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then(
            (m) => m.PAYMENTS_ROUTES
          )
      },
      {
        path: 'income',
        loadChildren: () =>
          import('./features/income/income.routes').then((m) => m.INCOME_ROUTES)
      },
      {
        path: 'expenses',
        loadChildren: () =>
          import('./features/expenses/expenses.routes').then(
            (m) => m.EXPENSES_ROUTES
          )
      },
      {
        path: 'reports',
        canActivate: [roleAccessGuard],
        data: { allowRoles: ['ADMIN', 'COM_COMPTE', 'PRESIDENT'] },
        loadChildren: () =>
          import('./features/reports/reports.routes').then(
            (m) => m.REPORTS_ROUTES
          )
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./features/accounts/accounts.routes').then(
            (m) => m.ACCOUNTS_ROUTES
          )
      },
      {
        path: 'caisse',
        canActivate: [roleAccessGuard],
        data: { allowRoles: ['ADMIN', 'COM_COMPTE', 'PRESIDENT'] },
        loadChildren: () =>
          import('./features/caisse/caisse.routes').then(
            (m) => m.CAISSE_ROUTES
          )
      },
      {
        path: 'draws',
        canActivate: [roleAccessGuard],
        data: { allowRoles: ['ADMIN', 'SECRETARY'] },
        loadChildren: () =>
          import('./features/draws/draws.routes').then(
            (m) => m.DRAWS_ROUTES
          )
      },
      {
        path: 'settings',
        canActivate: [roleAccessGuard],
        data: { denyRoles: ['MEMBER', 'SECRETARY', 'COM_COMPTE', 'TREASURER'] },
        loadChildren: () =>
          import('./features/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          )
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then(
            (m) => m.PROFILE_ROUTES
          )
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
